module.exports = __webpack_public_path__ + "static/media/icon25.c6443f33.png";